/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { ReduxStateLoadable } from '@reducers/types';
import { AnyAction } from 'redux';
import { IndustrySector } from '../types/common';

type State = ReduxStateLoadable<IndustrySector[]>;

const getDefaultState = (): State => ({
  data: undefined,
  loaded: false,
  errored: false,
  errorMessage: '',
  lastUpdated: Date.now()
});

const industrySectors = (
  state = getDefaultState(),
  action: AnyAction
): State => {

  switch (action.type) {
    case actionTypes.LOADING_INDUSTRY_SECTORS:
      return {
        ...state,
        data: undefined,
        loading: true,
        loaded: false,
        errored: false,
        lastUpdated: Date.now()
      }
    case actionTypes.ERROR_INDUSTRY_SECTORS:
      return {
        ...state,
        data: undefined,
        loading: false,
        loaded: false,
        errored: true,
        lastUpdated: Date.now(),
        errorMessage: action.errorMessage
      }
    case actionTypes.LOADED_INDUSTRY_SECTORS:
      return {
        ...state,
        data: action.data,
        loading: false,
        loaded: true,
        errored: false,
        lastUpdated: Date.now()
      }
    default:
      return state;
  }
}

export default industrySectors;
